import { getPagePath } from '@spotahome/soyuz/client';

const SPAIN_TRANSLATIONS = {
  es: 'espana',
  en: 'spain',
  fr: 'espagne',
  it: 'spagna',
  de: 'spanien',
  pt: 'espanha'
};

const FRANCE_TRANSLATIONS = {
  es: 'francia',
  en: 'france',
  fr: 'france',
  it: 'francia',
  de: 'frankreich',
  pt: 'franca'
};

const ITALY_TRANSLATIONS = {
  es: 'italia',
  en: 'italy',
  fr: 'italie',
  it: 'italia',
  de: 'italien',
  pt: 'italia'
};

const GERMANY_TRANSLATIONS = {
  es: 'alemania',
  en: 'germany',
  fr: 'allemagne',
  it: 'germania',
  de: 'deutschland',
  pt: 'alemanha'
};

const PORTUGAL_TRANSLATIONS = {
  es: 'portugal',
  en: 'portugal',
  fr: 'portugal',
  it: 'portogallo',
  de: 'portugal',
  pt: 'portugal'
};

const UK_TRANSLATIONS = {
  es: 'reino-unido',
  en: 'united-kingdom',
  fr: 'royaume-uni',
  it: 'regno-unito',
  de: 'grossbritannien',
  pt: 'reino-unido'
};
const COUNTRY_TRANSLATIONS = {
  spain: SPAIN_TRANSLATIONS,
  france: FRANCE_TRANSLATIONS,
  italy: ITALY_TRANSLATIONS,
  germany: GERMANY_TRANSLATIONS,
  portugal: PORTUGAL_TRANSLATIONS,
  uk: UK_TRANSLATIONS
};

const COUNTRY_TRANSLATIONS_BY_ISO_CODE = {
  ES: SPAIN_TRANSLATIONS,
  FR: FRANCE_TRANSLATIONS,
  IT: ITALY_TRANSLATIONS,
  DE: GERMANY_TRANSLATIONS,
  PT: PORTUGAL_TRANSLATIONS,
  GB: UK_TRANSLATIONS
};

export const getNewCountryUrl = (countryId, locale) => {
  if (!COUNTRY_TRANSLATIONS?.[countryId]?.[locale]) {
    return null;
  }

  return getPagePath('countries', {
    params: {
      country: COUNTRY_TRANSLATIONS[countryId][locale]
    }
  });
};

export const getNewCountryTranslationByIsoCode = (isoCode, locale) => {
  if (!COUNTRY_TRANSLATIONS_BY_ISO_CODE?.[isoCode]?.[locale]) {
    return null;
  }

  return getPagePath('countries', {
    params: {
      country: COUNTRY_TRANSLATIONS_BY_ISO_CODE[isoCode][locale]
    }
  });
};
